import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "vr_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    tab: "quiz",
    title: "Game Content",
    body: "This is where you add quiz questions, how-to-play rules, race images, and an optional car race sound.",
  },
  {
    id: "tabs",
    target: "tour-gc-tabs",
    tab: "quiz",
    title: "Quiz and Game Image tabs",
    body: "Use Quiz for questions and stage rules. Switch to Game Image to upload the road, cars, obstacles, and race sound.",
  },
  {
    id: "rules",
    target: "tour-gc-stage-rules",
    tab: "quiz",
    title: "How to play rules",
    body: "Write the help tips shown when players tap (?). Add or remove lines, then Save rules.",
  },
  {
    id: "questions",
    target: "tour-gc-quiz",
    tab: "quiz",
    title: "Add quiz questions",
    body: "Add questions one by one, or upload a CSV. You can also export or download a sample CSV.",
  },
  {
    id: "game-images",
    target: "tour-gc-game-images",
    tab: "game_image",
    title: "Game images",
    body: "Upload the road, cars, and obstacles. Each image must match the required pixel size shown under the section.",
  },
  {
    id: "road",
    target: "tour-gc-road",
    tab: "game_image",
    title: "Road image",
    body: "Upload one road image at the required size. This scrolls behind the player car during the race.",
  },
  {
    id: "cars-obstacles",
    target: "tour-gc-cars",
    tab: "game_image",
    title: "Cars and obstacles",
    body: "Add car and obstacle images with + Add. Exact dimensions are required so they look sharp in-game.",
  },
  {
    id: "race-sound",
    target: "tour-gc-race-sound",
    tab: "game_image",
    title: "Car race sound",
    body: "Optionally upload a looping engine/race audio bed. Players hear it while racing; leave empty to use the default sound.",
  },
  {
    id: "save",
    target: "tour-gc-save-images",
    tab: "game_image",
    title: "Save game images",
    body: "When your uploads look right, click Save Game Images to store them on the theme.",
  },
];

export default function ThemeUpdateFeatureTour({
  open,
  onClose,
  onStepChange,
  quizEnabled = true,
}) {
  const steps = quizEnabled
    ? THEMEUPDATE_TOUR_STEPS
    : THEMEUPDATE_TOUR_STEPS.filter((s) => s.id !== "questions").map((s) =>
        s.id === "welcome"
          ? {
              ...s,
              body: "This is where you add how-to-play rules, race images, and an optional car race sound.",
            }
          : s.id === "tabs"
            ? {
                ...s,
                body: "Use Quiz for how-to-play rules. Switch to Game Image to upload the road, cars, obstacles, and race sound.",
              }
            : s
      );

  return (
    <AdminFeatureTour
      open={open}
      onClose={onClose}
      steps={steps}
      onStepChange={onStepChange}
    />
  );
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
